export default __webpack_public_path__ + "static/eKgJMMbb-5e52fec43b34c3263e34d89f1dacbda1.svg";